(function (app) {

    app.provider("marketingTrackerSalesTrackerSettingsApi",
        [
            function () {
                this.$get = [
                    "marketingTrackerApiGateway", function (marketingTrackerApiGateway) {
                        var service = {};
                        //GETS
                        service.getAdvisorById = function (advisorId) {
                            return marketingTrackerApiGateway.get("/SalesTracker/Settings/Advisors/" + advisorId);
                        };
                        service.getAdvisors = function () {
                            return marketingTrackerApiGateway.get("/SalesTracker/Settings/Advisors");
                        };

                        service.getSourceById = function (sourceId) {
                            return marketingTrackerApiGateway.get("/SalesTracker/Settings/Sources/" + sourceId);
                        };
                        service.getSources = function () {
                            return marketingTrackerApiGateway.get("/SalesTracker/Settings/Sources");
                        };

                        service.getStatusById = function (statusId) {
                            return marketingTrackerApiGateway.get("/SalesTracker/Settings/Statuses/" + statusId);
                        };
                        service.getStatuses = function () {
                            return marketingTrackerApiGateway.get("/SalesTracker/Settings/Statuses");
                        };

                        service.getLinesOfBusinessById = function (lobId) {
                            return marketingTrackerApiGateway.get("/SalesTracker/Settings/LinesOfBusinesses" + lobId);
                        };
                        service.getLinesOfBusinessDetailsById = function (lobId) {
                            return marketingTrackerApiGateway.get("/SalesTracker/Settings/LinesOfBusinessDetails/" + lobId);
                        };
                        service.getLinesOfBusiness = function () {
                            return marketingTrackerApiGateway.get("/SalesTracker/Settings/LinesOfBusiness");
                        };
                        service.getLinesOfBusinessDetailsByTimeFrame = function (startDate, endDate) {
                            return marketingTrackerApiGateway.get("/SalesTracker/Settings/LinesOfBusinessDetails?startDate=" + startDate + "&endDate=" + endDate, {
                                    params: {
                                        startDate: startDate,
                                        endDate: endDate
                                    }
                                });
                        };
                        //service.getDashboardStuff = function (year) {
                        //    return marketingTrackerApiGateway.get("/SalesTracker/Dashboard?year=" + year,
                        //        {
                        //            params: {
                        //                year: year
                        //            }
                        //        });
                        //};

                        //POSTS
                        service.createAdvisor = function (advisor) {
                            return marketingTrackerApiGateway.post("/SalesTracker/Settings/Advisors", advisor);
                        };
                        
                        service.createSource = function (source) {
                            return marketingTrackerApiGateway.post("/SalesTracker/Settings/Sources", source);
                        };
                        
                        service.createStatus = function (status) {
                            return marketingTrackerApiGateway.post("/SalesTracker/Settings/Statuses", status);
                        };
                        
                        service.createLineOfBusiness = function (lob) {
                            return marketingTrackerApiGateway.post("/SalesTracker/Settings/LinesOfBusiness", lob);
                        };
                        service.createLineOfBusinessDetails = function (lobDetails) {
                            return marketingTrackerApiGateway.post("/SalesTracker/Settings/LinesOfBusinessDetails", lobDetails);
                        };

                        //PUT
                        service.updateAdvisor = function (advisor) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Settings/Advisors/" + advisor.Id + "/Name", advisor);
                        };
                        service.updateAdvisorActiveStatus = function (advisor) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Settings/Advisors/" + advisor.Id + "/ActiveStatus", advisor);
                        };
                        service.updateAdvisorsOrders = function (advisors) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Settings/Advisors/Order", advisors);
                        };

                        service.updateSource = function (source) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Settings/Sources/" + source.Id + "/Name", source);
                        };
                        service.updateSourceActiveStatus = function (source) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Settings/Sources/" + source.Id + "/ActiveStatus", source);
                        };

                        service.updateStatus = function (status) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Settings/Statuses/" + status.Id + "/Name", status);
                        };
                        service.updateStatusActiveStatus = function (status) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Settings/Statuses/" + status.Id + "/ActiveStatus", status);
                        };
                        service.updateStatusParentStatus = function (status) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Settings/Statuses/" + status.Id + "/ParentStatus", status);
                        };

                        service.updateLineOfBusinessName = function (lob) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Settings/LinesOfBusiness/" + lob.Id + "/Name", lob);
                        };
                        service.updateLineOfBusinesActiveStatus = function (lob) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Settings/LinesOfBusiness/" + lob.Id + "/ActiveStatus", lob);
                        };
                        service.updateLineOfBusinessDetails = function (lobDetails) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Settings/LinesOfBusinessDetails/" + lobDetails.Id, lobDetails);
                        };
                        //service.getMetricsByTimeframe = function (startDate, endDate) {
                        //    return marketingTrackerApiGateway.get("/EmailMarketing/Metrics?startDate=" + startDate + "&endDate=" + endDate,
                        //        {
                        //            params: {
                        //                startDate: startDate,
                        //                endDate: endDate
                        //            }
                        //        });
                        //};
                        //service.getMetricsByMonth = function (year, month) {
                        //    return marketingTrackerApiGateway.get("/EmailMarketing/MetricsByMonth?year=" + year + "&month=" + month,
                        //        {
                        //            params: {
                        //                year: year,
                        //                month: month
                        //            }
                        //        });
                        //};

                        return service;
                    }
                ];
            }
        ]);
})(window.app); //jshint ignore:line